module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/patients/lab-order.component.css
// module id = ./src/app/views/patients/lab-order.component.css
// module chunks = main